import { ModuleListPage } from '@/features/modules/pages/ModuleListPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/projects/$projectSlug/modules')({
  component: ModuleListPage,
});
